import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Role hierarchy: admin > manager > operator
const roleHierarchy = {
  'admin': ['admin', 'manager', 'operator'],
  'manager': ['manager', 'operator'],
  'operator': ['operator']
};

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user's role allows access to any of the required roles
  if (allowedRoles) {
    const userPermissions = roleHierarchy[user.role] || [user.role];
    const hasPermission = allowedRoles.some(role => userPermissions.includes(role));
    
    if (!hasPermission) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};